import { render, staticRenderFns } from "./search_results.vue?vue&type=template&id=98d910ac&scoped=true"
import script from "./search_results.vue?vue&type=script&lang=js"
export * from "./search_results.vue?vue&type=script&lang=js"
import style0 from "./search_results.vue?vue&type=style&index=0&id=98d910ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d910ac",
  null
  
)

export default component.exports